import React, { FC, useCallback, useState } from 'react';
import { Input } from 'antd';
import { useConnection } from '../../../connection/Application';
import { TextBlock } from '../../../uicomp/atmos/content-block/ContentBlock';
import Link from 'next/link';

type Props = {
  value?: string;
  onChange?: (value?: string) => void;
};

export const ContactEmail: FC<Props> = (props) => {
  const [existingUser, setExistingUser] = useState<boolean>(false);
  const connection = useConnection();

  const publishValueChange = useCallback(
    (val: any) => {
      const email = val.target.value ?? undefined;
      // setValue(email);
      props.onChange?.(email);

      if (email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        connection
          .get(`users/profile/${email}`)
          .then((response) => {
            // message.success('User profile found');
            setExistingUser(true);
          })
          .catch((error) => {
            setExistingUser(false);
            if (error.status !== 404) {
              console.error('Error checking user profile:', error);
            }
          });
      }
    },
    [props, connection],
  );

  return (
    <>
      <div>
        <Input type="email" value={props.value} onChange={publishValueChange} />
        {existingUser && (
          <TextBlock>
            You have account with this Email <Link href="/login">Login</Link>
          </TextBlock>
        )}
      </div>
    </>
  );
};
